<template lang="pug">
  span
    el-button(slot='reference', size='mini', type='primary',
      @click='showHistoryLog') Ιστορικό
    span(v-html='historyHTML')
</template>

<script>
import sharedMethods from '../common/sharedMethods.js'

export default {
  mixins: [sharedMethods],
  props: {
    history: {}
  },
  data () {
    return {
      historyHTML: ''
    }
  },
  methods: {
    showHistoryLog () {
      if (this.historyHTML !== '') {
        this.historyHTML = ''
      } else {
        this.historyHTML = this.printJson(this.history)
      }
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/showHistoryButton.vue